export const NA_VALUE = 'N/A';
export const DASH = '-';

export const BACKEND_ARR_TVL_DECIMALS = 18;
export const BACKEND_PRICE_SUPPLY_DECIMALS = 21;
export const TRANCHE_SHARE_DECIMALS = BACKEND_PRICE_SUPPLY_DECIMALS;
export const MZUSD_DECIMALS = BACKEND_ARR_TVL_DECIMALS;
export const USDC_DECIMALS = 6;

export const DOCS_URL = 'https://docs.mezz.finance/';